import { gql } from "@apollo/client";

export const GAMES_WITH_ASSIGNMENT = gql`
  query GetGamesWithAssignment($labelId: Int!, $environmentId: Int!, $isActive: Boolean, $first: Int!, $after: Int!, $categoryType: String, $search: String, $comment: String, $brandname: String) {
    gamesWithAssignment(
      where: {
        labelId: $labelId
        environmentId: $environmentId
        isActive: $isActive
        categoryType: $categoryType
        search: $search
        comment: $comment
        brandname: $brandname
      }
      pagination: {
        first: $first
        after: $after
      }
    ) {
      games {
        id
        name
        gameId
        providerId
        categoryId
        launchUrl
        demoAvailable
        freespinAvailable
        deviceType
        betType
        linesCount
        isActive
        iconUrl
        description
        createdAt
        position
        isFavorite
        isAvailableInUserCountry
        restrictedCountries
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        total
      }
    }
  }
`;

export const LABELS_BY_ENVIRONMENT = gql`
  query LabelsByEnvironment($environmentId: Int!) {
    labelsByEnvironment(environmentId: $environmentId) {
      id
      name
      environmentId
      environment {
        id
        name
        host
      }
    }
  }
`;

export const GET_ENVIRONMENTS = gql`
  query GetEnvironments {
    environments {
      id
      name
      host
    }
  }
`;

export const ENTER_GAME = gql`
  mutation EnterGame($input: EnterGameInput!) {
    enterGame(input: $input) {
      sessionToken
      launchUrl
      balance
      currency
    }
  }
`;

export const EXIT_GAME = gql`mutation ExitGame($sessionToken: String!) {
  exitGame(
    input: {
        sessionToken: $sessionToken
    }
  ) {
    success
    userBalance
  }
}`

export const GET_BIG_WINS = gql`
  query GetBigWins(
    $environmentId: Int!
    $labelId: Int!
    $categoryType: String!
    $first: Int!
    $after: Int!
  ) {
    bigWins(
      where: { 
        environmentId: $environmentId,
        labelId: $labelId,
        categoryType: $categoryType
      }
      pagination: {
        first: $first,
        after: $after
      }
    ) {
      games {
        id
        name
        gameId
        providerId
        categoryId
        launchUrl
        demoAvailable
        freespinAvailable
        deviceType
        betType
        linesCount
        isActive
        iconUrl
        description
        createdAt
        isFavorite
        position
        comment
        winAmount
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        total
      }
    }
  }
`;

export const GET_ALL_BRANDS = gql`
query GetBrandNames($labelId: Int, $categoryType: String) {
  getBrandNames(labelId: $labelId, categoryType: $categoryType)
}
`;
export const GET_ALL_PROVIDERS = gql`
query FindAllProviders {
  findAllProviders {
    id
    name
    agentName
    isActive
  }
}
`;

export const GET_SUB_BET = gql`
mutation LoginSboBet {
    loginSboBetPlayer {
        success
        message
        webLoginUrl
        userBalance
    }
}
`;

export const ADD_FAVORITE = gql`
  mutation AddFavorite($gameId: Int!, $labelId: Int!) {
    addFavorite(input: { gameId: $gameId, labelId: $labelId }) {
      success
      message
      favorite {
        id
        gameId
      }
    }
  }
`;

export const REMOVE_FAVORITE = gql`
  mutation RemoveFavorite($gameId: Int!, $labelId: Int!) {
    removeFavorite(input: { gameId: $gameId, labelId: $labelId }) {
      success
      message
    }
  }
`;

export const GET_MY_FAVORITES = gql`
  query MyFavorites($labelId: Int!) {
    myFavorites(where: {labelId: $labelId}) {
      favorites {
        id
        gameId
        labelId
        createdAt
        game {
            id
        name
        gameId
        providerId
        categoryId
        launchUrl
        demoAvailable
        freespinAvailable
        deviceType
        betType
        linesCount
        isActive
        iconUrl
        description
        createdAt
        position
        isFavorite
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
        total
      }
    }
  }
`;